import { Link as LinkLi } from '@material-ui/core';
import { pageUrls } from 'globalconfig/constants/keys';
import { mediaUrls } from 'globalconfig/constants/mediaUrls';
import PropTypes from 'prop-types';
import React, { lazy, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import Filters from '../Filters';
import { getConfig } from './config';
import { checkServiceProvider } from './serviceProviderConfig';

const layout = window?.$environment?.CURRENT_LAYOUT;
const Table = lazy(() => import(`globalcomponents/UI/Table/${layout}`));
const Icon = lazy(() => import(`globalcomponents/UI/Icon/${layout}`));
const Button = lazy(() => import(`globalcomponents/UI/Button/${layout}`));
const Modal = require(`globalcomponents/UI/Modal/${layout}`).default;
const SvgIcon = lazy(() => import(`globalcomponents/SvgIcon/${layout}`));

const Component = ({
  trailers,
  handleDeleteAlert,
  callback,
  Styled,
  insuracePortalUserRole,
  fleetCompanyList,
  filterList,
  handleReset,
}) => {
  const SERVICE_PROVIDER = window?.$environment?.SERVICE_PROVIDER;
  const { i18n } = useTranslation();
  const [ModalListObject, setModalListObject] = useState({
    header: '',
    content: () => {},
  });
  const [open, setOpen] = useState(false);
  const [values, setInitialValues] = useState({
    companyId: null,
    unit_id: null,
  });

  const columns = useMemo(() => {
    return getConfig({ i18n, insuracePortalUserRole }).tableColumns;
  }, []);

  const generateRows = () => {
  return trailers;
  };

  return (
    <>
      <Styled.Wrapper>
        <Styled.TableWrapper insuracePortalUserRole={insuracePortalUserRole}>
          {insuracePortalUserRole && (
            <Filters
              fleetCompanyList={fleetCompanyList}
              filterList={filterList}
              handleReset={handleReset}
              values={values}
              setInitialValues={setInitialValues}
            />
          )}
          <Table
            type="client"
            defaultSortBy={{ sortBy: 'unit_id', order: 'asc' }}
            title=""
            columns={columns}
            data={generateRows()}
            emptyMessage={i18n.t('common.tableEmptyMessage')}
            itemsPerPage={window.$environment.CURRENT_LAYOUT === 'OldUi' ? 5 : 10}
            actions={[
              {
                icon: (row) => {
                  return (
                    <LinkLi component={Link} to={pageUrls.editTrailer.replace(':id', row.id)}>
                      <Icon src={mediaUrls?.edit} />
                    </LinkLi>
                  );
                },
              },
              ...(!checkServiceProvider('trailers_actions', SERVICE_PROVIDER, false)
                ? [
                    {
                      icon: (row) => {
                        return (
                          <Icon
                            src={mediaUrls?.deleteIcon}
                            onClick={() => {
                              setModalListObject({
                                content: () => (
                                  <div className="deleteParent">
                                    <div className="imageSection">
                                      <SvgIcon value={mediaUrls.confirmIcon} alt="Are you sure" />
                                    </div>
                                    <h2> {i18n.t('common.sureConfirm')} </h2>
                                    <p> {i18n.t('trailers.recoverConfirm')}</p>
                                    <div className="deletePopupBtn">
                                      <div className="cancelBtn">
                                        <Button
                                          label={i18n.t('Cancel')}
                                          type={'reset'}
                                          onClick={() => {
                                            setOpen(false);
                                          }}
                                        ></Button>
                                      </div>
                                      <div className="deletebtn">
                                        <Button
                                          label={i18n.t('common.deletePopup')}
                                          onClick={() => {
                                            handleDeleteAlert({
                                              id: 'deleteAlert',
                                              data: { id: row.id },
                                              callback: callback,
                                            });
                                            setOpen(false);
                                          }}
                                        ></Button>
                                      </div>
                                    </div>
                                  </div>
                                ),
                              });
                              setOpen(true);
                            }}
                          />
                        );
                      },
                    },
                  ]
                : []),
            ]}
            defaultSort={'unit_id'}
            i18n={i18n}
          />
        </Styled.TableWrapper>
      </Styled.Wrapper>
      <Modal open={open} setOpen={setOpen} data={ModalListObject} deletePopup />
    </>
  );
};

export default Component;

Component.propTypes = {
  history: PropTypes.object.isRequired,
};
